class VgLogin extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.email = this.getAttribute('email-value');
        this.password;
        this.submitText = this.getAttribute('submit-text');
        this.cancelText = this.getAttribute('cancel-text');
        this.vgApiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
        this.vgForms = new VGForms();

        this.mount();
    }

    mount() {
        let form = document.createElement('form');
        form.method = 'POST';
        // TODO: get translations from wp_localize_script or options
		let countryPath = VgHelpers.getActualDomain();
		let forgotPasswordText = vgHelpersData.options.settings.vg_str_forgot_password;
		let forgotPasswordLink = vgHelpersData.options.settings.vg_link_forgot_password;

		form.innerHTML += `
		<div class="vg-joining-step-data-goup-form">
			<div ${ (this.email) ? 'style="display:none"' : '' } >
				<div class="vg-form__field-group is-required">
					<label for="login-email">Email</label>
					<div class="vg-form__field-element">
						<input id="login-email" name="login-email" type="email" value="${this.email ?? ''}"
							data-testid="login-email" ${ (this.email) ? 'readonly' : 'required' }>
						<vg-tooltip>
							<i class="icon icon--help-question vg-tooltip__trigger"></i>
							<div class="vg-tooltip__panel">Got a tooltip</div>
						</vg-tooltip>
					</div>
				</div>
			</div>
			<div>
				<div class="vg-form__field-group vg-form__field-group--password has-tooltip is-required">
					<label for="login-password">Contraseña</label>
					<div class="vg-form__field-element">
						<input id="login-password" name="login-password" type="password" value="" data-testid="login-password" required>
						<vg-tooltip>
							<i class="icon icon--help-question vg-tooltip__trigger"></i>
							<div class="vg-tooltip__panel">Got a tooltip</div>
						</vg-tooltip>
						<i class="icon icon--eye"></i>
					</div>
					<div class="vg-form__field-message">
						<a href="${forgotPasswordLink}" target=”_blank” class="vg-form__link-reset-password">${forgotPasswordText}</a>
					</div>
				</div>
			</div>
		</div>
		<div class="vg-modal__cta">
			<button type="button" class="cancel-btn ob-button ob-button--outline">${this.cancelText}</button>
			<input type="submit" class="ob-button ob-button--primary" value="${this.submitText}" disabled>
		</div>
		`;



        this.appendChild(form);

		const passwordFields = document.querySelectorAll(
			".vg-form__field-group--password"
		);
		this.vgForms.initFieldLogicPassword(passwordFields);

        this.submitEnable(form);
        this.sumbmitControl(form);
    }

    // Add event listener to the form
    sumbmitControl(form) {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            const data = {};
            const inputs = form.querySelectorAll('input');
            inputs.forEach(input => {
				if ('login-password' === input.name) {
					data["password"] = input.value;
				} else {
					data[input.type] = input.value;
				}
            });

            const login = await this.loginUser(data.email, data.password);

            document.dispatchEvent(new CustomEvent('VgLoginAttempt', { detail: {email : data.email} }));
            console.log('Event: VgLoginAttempt', {email : data.email});
        });
    }

    async loginUser(userEmail, userPassword) {
        const submitButton = this.querySelector('input[type="submit"]');
        submitButton.disabled = true;

        this.vgApiClient.action = "login_user_data";
		this.vgApiClient.params = { email: userEmail, password: userPassword };

        this.vgApiClient.handleRequest().then((data) => {
            let loginSuccess = false;
            let response = data;

            if (data.error != null) {
                response = data.error;
                submitButton.disabled = false;
            }

            if (data.error == null && data.personData != null) {
                response = data.personData;
                loginSuccess = true;
            }
			let token = data.token;
            let loginData = { success: loginSuccess, userEmail: userEmail,response: response, password: userPassword, corporateMember: data.corporateMember, new_token: token };
            document.dispatchEvent(new CustomEvent('VgLogin', { detail: loginData }));
            console.log('Event: VgLogin', loginData);

			if (response.personTypeAndStatus) {
				if (response.personTypeAndStatus.blacklisted === true) {
					location.href = vgHelpersData.options.modals[1].modal_redirect_url;
					return;
				}
			}

            return response;
        });
    }

    submitEnable(form) {
        form.addEventListener('input', (event) => {
            event.preventDefault();
            const submit = form.querySelector('input[type="submit"]');
            const email = form.querySelector('input[type="email"]');
            const allFilled = Array.from(form.querySelectorAll('input[type="email"], input[type="password"]')).every(input => input.value.trim() !== "");
            const rules = [
                {
                    rule: "regexp",
                    params: { regexp: /^[^@\s.][^@\s]*@[A-Za-z0-9-]{1,}\.[A-Za-z]{2,}$/, error_message: "Formato email incorrecto" }
                },
            ];

            let validEmail = this.vgForms.isValid(email.value, email, rules);
            submit.disabled = !allFilled || !validEmail;
        });
    }
}

customElements.define('vg-login', VgLogin);
